
export const DISALLOWED_WORDS: string[] = [
    'shit',
    'fuck',
    'nigg',
    'asshole',
    'fag',
    'phuck',
    'pussy',
    'dyke',
    'dickhead',
    'bitch',
    'cunt', 
    'cock',
    'webmaster',
    'postmaster',
    'administrator',
    'admin',
    'root',
    'support',
    'xap',
    'mail',
    'mentor',
    'www',
    'info',
    'comments',
    'counselor',
    'help'


];

export const DISALLOWED_WORDS_REGEX: RegExp = new RegExp('/' + DISALLOWED_WORDS.join('|') + '/g');

    //'^(?!(?:static|my|admin|www)$).*$'
